import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from './App.vue'
import router from './router'
import manager from './manager'
import VueSnip from 'vue-snip'
import AOS from 'aos'
import 'aos/dist/aos.css'
import gtm from '@/plugins/vue-gtm'
import configuration from './configuration'

AOS.init({
  delay: 300,
  duration: 400,
  easing: 'ease',
})

import 'virtual:windi.css'
import './styles/normalize.css'
import './styles/index.css'

const head = createHead()

createApp(App)
  .use(head)
  .use(router)
  .use(manager)
  .use(VueSnip)
  .use(gtm, { id: configuration('gtmId'), router })
  .mount('#app')
